import {
  cloneElement,
  type ReactElement,
  type ReactNode,
  type MouseEvent,
  type JSX,
} from 'react';
import { type LinkSize, useLinkStyles } from './link.styles';
import { type ThemeNames } from '../../../theme';
import { BodyS, CaptionLink, FontWeight } from '../../../typography';
import { IconProps } from '@doxyme/icons';

export type LinkProps = {
  id?: string;
  children: ReactNode | string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  size?: LinkSize;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  themeName?: ThemeNames;
  className?: string;
  fontWeight?: FontWeight;
  isDisabled?: boolean;
};

export const Link = ({
  id,
  children,
  startIcon,
  endIcon,
  size = 'regular',
  onClick,
  themeName,
  className,
  fontWeight,
  isDisabled = false,
}: LinkProps): JSX.Element => {
  const styles = useLinkStyles({ themeName });
  const Element = size === 'regular' ? BodyS : CaptionLink;

  return (
    <button
      id={id}
      css={styles.container}
      className={className}
      type='button'
      onClick={onClick}
      disabled={isDisabled}
    >
      {Boolean(startIcon) &&
        cloneElement(startIcon as ReactElement<IconProps>, {
          css: styles.icon,
        })}
      <Element
        tag='span'
        css={styles.link}
        color='inherit'
        fontWeight={fontWeight}
      >
        {children}
      </Element>
      {Boolean(endIcon) &&
        cloneElement(endIcon as ReactElement<IconProps>, {
          css: styles.icon,
        })}
    </button>
  );
};
